let spinnerDiv = document.createElement("div");
spinnerDiv.classList.add("lds-spinner");

spinnerDiv.setAttribute("tabindex", "-1");
spinnerDiv.style.zIndex = 2147483647;
spinnerDiv.setAttribute("id", "spinnerFullpage");
spinnerDiv.innerHTML =
  "<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>";

export function addGlobalSpinner() {
  let spinner = document.getElementById("spinnerFullpage");
  if (!spinner) document.getElementById("root").appendChild(spinnerDiv);
}

export function removeGlobalSpinner() {
  let spinner = document.getElementById("spinnerFullpage");
  if (spinner) document.getElementById("root").removeChild(spinner);
}
